<template>
    <aside class="sticky d-flex justify-content-start align-items-stretch px-0 bg-dark">
        <!-- ======= Sidebar ======= -->
        <div class="d-flex flex-column align-items-center px-3 pt-2 text-white min-vh-100"><!-- align-items-sm-start -->
            <div class="w-100">
                <a href="/" class="d-flex flex-column text-white text-decoration-none">
                    <img class="img-fluid" v-bind:src="$glob.logoSquare" v-bind:alt="$glob.companyShortName + ' Mark'"/>
                </a>
            </div>
            <hr>
            <ul class="nav nav-pills flex-column mb-auto">
            <!-- Pages from main.js -->
            <template v-for="$page in $pages" :key="$page.id">
                <template v-if="$page.enabled">
                    <li>
                        <router-link class="nav-link text-white" active-class="nav-link-active text-bs" :to="{name: $page.name}">
                            <component :is="$page.icon" /><span class="ms-1 d-none d-sm-inline">{{$page.name}}</span>
                        </router-link>
                    </li>
                </template>
            </template>
            <hr>
            <!-- Links from main.js -->
            <template v-for="$link in $links" :key="$link.id">
                <template v-if="$link.enabled">
                    <li>
                        <a :href="$link.url" target="_blank" class="nav-link text-white">
                            <icon-base v-if="$link.iconBase"><component :is="$link.icon" /></icon-base><component v-else :is="$link.icon" /><span class="ms-1 d-none d-sm-inline">{{$link.name}}</span>
                        </a>
                    </li>
                </template>
            </template>
            <hr>
            <template v-for="$page in $legalpages" :key="$page.id">
                <template v-if="$page.enabled">
                    <li>
                        <router-link :class="{ 'nav-link': !$page.small, 'nav-link-legal m-3': $page.small, 'text-white':true }" :to="{name: $page.name}">
                            <component v-if="!!$page.icon" :is="$page.icon" /><span :class="{'ms-1':1, 'd-none':!$page.small, 'd-sm-inline':!$page.small}">{{$page.name}}</span>
                        </router-link>
                    </li>
                </template>
            </template>
            </ul>
            <template v-if="$glob.enableLogin">
                <div class="d-flex align-items-end justify-content-start w-100 pb-3">
                    <div class="dropdown">
                        <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
                            Admin
                        </a>
                        <ul class="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1">
                            <li><a class="dropdown-item" href="#">Add Event</a></li>
                            <li><a class="dropdown-item" href="#">Add Sponsor</a></li>
                            <li><a class="dropdown-item" href="#">Add History</a></li>
                            <li><a class="dropdown-item" href="#">Manage Page</a></li>
                            <li><a class="dropdown-item" href="#">Settings</a></li>
                            <li><a class="dropdown-item" href="#">Profile</a></li>
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item" href="#">Sign out</a></li>
                        </ul>
                    </div>
                </div>
            </template>
        </div>
    </aside>
</template>

<style scoped>
    .aside.div {
        z-index: 999;
    }
    .img-fluid {
        max-width: 100%;
        height: auto;
    }
</style>

<script>
    /* eslint-disable vue/no-unused-components */
    // import VBTooltip from 'bootstrap-vue'

    import IconBase from './IconBase.vue'
    import IconFacebook from './icons/IconFacebook.vue'
    import IconInstagram from './icons/IconInstagram.vue'
    import IconYoutube from './icons/IconYoutube.vue'

    import IconAt from 'vue-material-design-icons/At.vue'
    import IconAbout from 'vue-material-design-icons/AccountGroup.vue'
    import IconLaser from 'vue-material-design-icons/LaserPointer.vue'
    import IconCompass from 'vue-material-design-icons/RulerSquareCompass.vue'
    import IconPrinter from 'vue-material-design-icons/Printer3d.vue'
    import IconAccount from 'vue-material-design-icons/AccountCircle.vue'
    import IconMarker from 'vue-material-design-icons/Marker.vue'
    import IconCalendar from 'vue-material-design-icons/CalendarMonth.vue'
    import IconCash from 'vue-material-design-icons/CashMultiple.vue'
    import IconHistory from 'vue-material-design-icons/History.vue'
    import IconHome from 'vue-material-design-icons/Home.vue'
    import IconHandshake from 'vue-material-design-icons/Handshake.vue'
    import IconFundraise from 'vue-material-design-icons/HandHeart.vue'
    import IconSticker from 'vue-material-design-icons/StickerCircleOutline.vue' //StickerEmoji.vue'
    import IconSublimation from 'vue-material-design-icons/PanoramaVariantOutline.vue'

    export default {
        name: 'SidebarNav',
        components: {
            // VBTooltip,
            IconAccount,
            IconBase,
            IconCalendar,
            IconCash,
            IconFacebook,
            IconHistory,
            IconHome,
            IconInstagram,
            IconLaser,
            IconCompass,
            IconPrinter,
            IconMarker,
            IconSticker,
            IconSublimation,
            IconYoutube,
            IconAt,
            IconAbout,
            IconHandshake,
            IconFundraise,
        },
    }
</script>